export const WEEKDAY_ORDINALS = [
  { value: -5, description: "5th from the end of the month" },
  { value: -4, description: "4th from the end of the month" },
  { value: -3, description: "3rd from the end of the month" },
  { value: -2, description: "2nd from the end of the month" },
  { value: -1, description: "Last in the month" },

  { value: 1, description: "1st in the month" },
  { value: 2, description: "2nd in the month" },
  { value: 3, description: "3rd in the month" },
  { value: 4, description: "4th in the month" },
  { value: 5, description: "5th in the month" },
];
